import { createContext } from 'react';

const CongregationContext = createContext();//CurrentContextData);

export default CongregationContext;
